import React from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

/**
 * Failed-request placeholder for a Reports tab.
 *
 * Deliberately distinct from ReportsEmptyState: a failed fetch must never be
 * presented as "no data", because the two mean opposite things to the user.
 */
const ReportsErrorState = ({ title, message, onRetry, iconSize = 64, padding = 6 }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        p: padding,
        textAlign: 'center'
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: iconSize, color: theme.palette.error.main, mb: iconSize >= 64 ? 2 : 1 }} />
      <Typography variant="h6" color="text.primary" sx={{ mb: 1, fontWeight: 500 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 400, mb: 2 }}>
        {message}
      </Typography>
      {onRetry && (
        <Button variant="outlined" size="small" onClick={onRetry}>
          Retry
        </Button>
      )}
    </Box>
  );
};

export default ReportsErrorState;
